import { useEffect } from 'react';

/**
 *
 * @desc Hook that detects clicks outside of a given element.
 * @param {*} elementRef
 * @param {*} callback
 *
 */
function useClickOutside(elementRef, callback) {

    const handleClick = (event) =>  {

        const element = elementRef.current;

        if (!element) {

            return;

        }

        if (!element.contains(event.target)) {

            callback();

        }

    };

    useEffect(() => {

        window.addEventListener('click', handleClick);

        return () => {

            window.removeEventListener('click', handleClick);

        };

    });

}

export default useClickOutside;
